import React, { useState } from "react"
import Header from "../components/Header"
import ImageGrid from "../components/ImageGrid"
import Footer from "../components/Footer"
import TickerBar from "../components/TickerBar"
import { useSortContext } from "../components/SortContext"

const HomePage = () => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)
    const { selectedOption, setSelectedOption, selectedCategory, setSelectedCategory } = useSortContext()

    return (
        <div style={{ margin: 0, padding: 0, overflowX: "hidden" }}>
            <TickerBar />
            <Header
                isDropdownOpen={isDropdownOpen}
                setIsDropdownOpen={setIsDropdownOpen}
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
            />
            <ImageGrid
                containerWidth="100%"
                containerHeight="auto"
                selectedOption={selectedOption}
                selectedCategory={selectedCategory}
            />
            <Footer />
        </div>
    )
}

export default HomePage